module.exports = __webpack_public_path__ + "static/media/clock.2904a893.png";